import { SectionContent, SectionHeader } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';

export interface ISectionProps {
	id?: string;
	sectionHeader: any;
	hide?: boolean;
}

const StyledSection = styled.div`
	.tws-displaycard-container {
		padding: 0;
	}
`;
StyledSection.displayName = 'StyledSection';

export class Section extends React.PureComponent<React.PropsWithChildren<ISectionProps>> {
	public render() {
		return (
			!this.props.hide && (
				<StyledSection id={this.props.id}>
					<SectionHeader>{this.props.sectionHeader}</SectionHeader>
					<SectionContent>{this.props.children}</SectionContent>
				</StyledSection>
			)
		);
	}
}
